import { t } from '@lingui/core/macro';

// Compact relative-time formatter for scan timestamps: "just now", "5m ago",
// "2h ago", "yesterday", "3d ago". Returns "—" for null/unparseable input.
export function formatRelativeTime(iso: string | null): string {
  if (!iso) return '—';
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '—';
  const sec = Math.round((Date.now() - then) / 1000);
  const min = Math.round(sec / 60);
  const hr = Math.round(min / 60);
  const day = Math.round(hr / 24);
  if (sec < 45) return t`just now`;
  if (min < 60) return t`${min}m ago`;
  if (hr < 24) return t`${hr}h ago`;
  if (day === 1) return t`yesterday`;
  if (day < 30) return t`${day}d ago`;
  const mon = Math.round(day / 30);
  if (mon < 12) return t`${mon}mo ago`;
  const yr = Math.round(day / 365);
  return t`${yr}y ago`;
}

// Absolute, human-readable date + time, e.g. "Jun 24, 2026, 9:30 AM". "—" for null/unparseable.
export function formatAbsoluteDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
